module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Art Organization Creative House","short_name":"Creative House","start_url":"/","background_color":"#fff","theme_color":"#000","display":"standalone","icon":"/opt/build/repo/src/img/favicon3.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"884fe3d4b14346f4a4ba1d04f2dbe1b9"},
    },{
      plugin: require('../node_modules/gatsby-plugin-react-helmet-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://www.creative-house.art/"},
    }]
